export interface ConferenceBrandMediaPayload {
  contentUrl?: string;
  fileType?: string;
  videoPoster?: string;
}

const VIDEO_EXT = /\.(mp4|mov|webm|ogg)(\?.*)?$/i;

export const getConferenceBrandPosterUrls = (
  brands?: ConferenceBrandMediaPayload[]
) => [
  ...new Set(
    (brands || [])
      .map((brand) => brand.videoPoster?.trim())
      .filter((url): url is string => Boolean(url))
  ),
];

export const getConferenceMobileBrandImageUrl = (url: string) => {
  try {
    const parsedUrl = new URL(url);
    const supportsImageProcessing =
      parsedUrl.hostname.endsWith('.gtimg.com') ||
      parsedUrl.hostname.endsWith('.ssv.tencent.com');
    if (!supportsImageProcessing) return url;

    const separator = parsedUrl.search ? '&' : '?';
    return `${url}${separator}imageMogr2/thumbnail/1080x/quality/75`;
  } catch {
    return url;
  }
};

export const getConferenceMobileBrandPreloadUrl = (
  brands?: ConferenceBrandMediaPayload[]
) => {
  const imageUrl = (brands || []).find((brand) => {
    if (!brand.contentUrl) return false;
    if (brand.fileType?.toLowerCase() === 'video') return false;
    return !VIDEO_EXT.test(brand.contentUrl);
  })?.contentUrl;

  return imageUrl ? getConferenceMobileBrandImageUrl(imageUrl) : '';
};
